import { EMAIL_SALES } from '@app/config';
import { FaqAccordionItems } from '@app/widgets';

export const ENTERPRISE_FAQS: FaqAccordionItems[] = [
  {
    question: 'What regions or data centers do you use?',
    answer: [
      'Our services are hosted on more than 330 servers in over 125 countries worldwide, ensuring low latency and high availability for your users.',
      'We use multiple data centers to ensure redundancy and reliability.',
    ].join(' '),
  },
  {
    question: 'What security measures do you have in place?',
    answer: [
      'We take security very seriously and have implemented multiple layers of security to protect your data.',
      'This includes encryption at rest and in transit, isolated build environments, regular security audits, and compliance with industry standards such as GDPR and SOC 2 Type II.',
      'We also offer self-hosting options for Live Updates and dedicated infrastructure for builds when required.',
      `For more information, please visit our <a href="https://cloud.capawesome.io/trust/">Trust & Security</a> page or contact our <a href="mailto:${EMAIL_SALES}" target="_blank">sales team</a>.`,
    ].join(' '),
  },
  {
    question: 'Do you offer an SLA (Service Level Agreement)?',
    answer: [
      'Yes, we offer an SLA for our Enterprise customers. The SLA guarantees a certain level of availability and response times for support requests.',
      'You can find more information about our SLA <a href="https://capawesome.io/sla/" target="_blank">here</a>.',
    ].join(' '),
  },
  {
    question: 'Do you offer a DPA (Data Processing Agreement)?',
    answer: [
      'Yes, we offer a DPA for all customers to ensure compliance with data protection regulations such as GDPR.',
      'You can find more information about our DPA <a href="https://capawesome.io/dpa/" target="_blank">here</a>.',
    ].join(' '),
  },
  {
    question: 'Do you offer dedicated support channels?',
    answer: [
      'Yes, we offer dedicated support channels for our Enterprise customers on Discord and Slack.',
      'You can also reach out to us via email or schedule a call with our support or engineering team.',
      `For more information, please contact our <a href="mailto:${EMAIL_SALES}" target="_blank">sales team</a>.`,
    ].join(' '),
  },
  {
    question: 'Which payment methods do you accept?',
    answer: [
      'We accept various payment methods including credit cards, bank transfers, and PayPal.',
      'For larger organizations, we can also provide invoicing options.',
      `For more information, please contact our <a href="mailto:${EMAIL_SALES}" target="_blank">sales team</a>.`,
    ].join(' '),
  },
];
